var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { conversationChannelAttributes, } from 'lib-shared-legacy-types';
import { useSetState } from 'react-use';
import { analytics } from 'app/utils/segment';
import { bansApi } from 'hooks/useBans/api';
import { useNotifications } from 'hooks/useNotifications';
const { unbanUser } = bansApi;
export const UnbanUserModal = (props) => {
    var _a;
    const [state, setState] = useSetState({
        isBanning: false,
    });
    const notify = useNotifications();
    const handleClose = (event) => {
        props.onClose(event);
    };
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        const { user: { id }, channel, } = props;
        const { reason } = state;
        analytics.bansUnbanUserClicked({
            channel,
        });
        setState({ isBanning: true });
        try {
            const response = yield unbanUser(id, {
                channel,
                reason,
            });
            const notificationPayload = {
                title: 'User unbanned',
                text: `User has been unbanned`,
                icon: 'i-done',
                className: 'success',
                time: 5000,
            };
            notify(notificationPayload);
            setState({ isBanning: false });
            handleClose({ response });
        }
        catch (error) {
            setState({ isBanning: false });
            const notificationPayload = {
                title: 'An error occurred',
                text: `An error occurred when trying to unban user`,
                icon: 'i-exclamation',
                className: 'danger',
            };
            notify(notificationPayload);
            throw new Error('Failed to unban user');
        }
    });
    const handleCancel = () => {
        handleClose({ canceled: true });
    };
    const { isOpen, user: { name }, channel, } = props;
    const channelName = (_a = conversationChannelAttributes.get(channel)) === null || _a === void 0 ? void 0 : _a.prettyName;
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleCancel }, { children: [_jsx(ModalHead, { title: "Are you sure?", onClose: handleCancel }), _jsx(ModalBody, { children: _jsxs(Text.Paragraph, { children: ["Are you sure you want to unban user ", _jsx("strong", { children: name }), " from the", ' ', _jsx("strong", { children: channelName }), " channel?"] }) }), _jsx(ModalFoot, { cancelName: "Cancel", cancelOnClick: handleCancel, confirmName: "Unban user", confirmProps: {
                    isLoading: state.isBanning,
                    loadingIndicator: (_jsx(Text.Paragraph, Object.assign({ as: "span", variant: "3", wrap: "nowrap", color: "inherit" }, { children: "Unbanning..." }))),
                }, confirmOnClick: handleConfirm })] })));
};
